/**
 * Do not edit directly, this file was auto-generated.
 */

export const ControlHeightTiny = '18px'; // Inline-text marker — Badge only
export const ControlHeightXs = '24px'; // Compact glyph-row — Checkbox / Radio / Toggle / Chip / Badge
export const ControlHeightS = '32px'; // Compact functional control — Button / Input / SegmentedButton / CRT / Chip / Badge
export const ControlHeightSm = '36px'; // Half-step between s and m — Input / Chip
export const ControlHeightM = '48px'; // Normal — pivot. All functional atoms support this step.
export const ControlHeightL = '64px'; // Hero — Button / SegmentedButton only
export const ControlHeightXl = '96px'; // Tallest step — composite field blocks that reserve room for a control plus its inline error / swapped state, e.g. the OTP / verify-code slot. Not a single-control height.
export const ControlPaddingXS = '8px'; // Horizontal padding for control.height.s
export const ControlPaddingXM = '16px'; // Horizontal padding for control.height.m
export const ControlPaddingXL = '24px'; // Horizontal padding for control.height.l
export const ControlGapS = '4px'; // Inside Small control (32h)
export const ControlGapM = '8px'; // Inside Normal control (48h)
export const ControlGapL = '8px'; // Inside Big control (64h) — same as m, larger gap looks wrong
export const ControlIconSizeS = '20px'; // In Small control
export const ControlIconSizeM = '24px'; // In Normal control
export const ControlIconSizeL = '24px'; // In Big control — same as Normal; only hero icons go 32
export const IconSizeXs = '16px'; // Inline with text, dense controls, micro-indicators
export const IconSizeS = '20px'; // In Small interactive controls
export const IconSizeM = '24px'; // DEFAULT — in Normal controls, standalone icons
export const IconSizeL = '28px'; // Larger nav icons (Page Header buttons)
export const IconSizeXl = '32px'; // Hero icons, empty-state illustrations
export const TouchTargetMin = '48px'; // WCAG minimum touch target.
export const TouchTargetComfortable = '52px'; // Small-screen primary actions.
export const TouchTargetLarge = '60px'; // Header nav buttons (notifications, account).
